import { observer } from "mobx-react-lite";
import DynamicTableComponent from "../../DynamicTable/DynamicTableComponent";
import { useStore } from "../../../app/stores/store";
import { toast } from "react-toastify";
import _ from "lodash";

interface Props {
  tableDetails: any[];
  tableName: string;
  loading: boolean;
  pageNumber: number;
  pageSize: number;
  setPageNumber: any;
  setMailItem: any;
  handleUnreadMail: (value: any) => void;
}

const EmailTable = ({
  tableDetails,
  tableName,
  loading,
  setMailItem,
  setPageNumber,
  pageNumber,
  pageSize,
  handleUnreadMail,
}: Props) => {
  const { dashboardStore, EmailMessageStore } = useStore();

  const ReadMailCheckboxFunc = async (id: string, content: string) => {
    try {
      await EmailMessageStore.checkedMail(id);
      handleUnreadMail('');
      toast.success(`${content} Mail Moved to Read Successfully...`);
    } catch (error) {
      console.error("Error moving mail to read:", error);
    }
  };

  const searchHandler = async (newObj: any, pagenumber: number, condition: string) => {
    const stringfyValue = JSON.stringify(newObj);
    const isReadMail = condition === 'ReadMail';
    const response: any = isReadMail
      ? await EmailMessageStore.handleReadMail(stringfyValue, pagenumber)
      : await EmailMessageStore.handleUnreadMail(stringfyValue, pagenumber);

    const [updatedMail, updatedMailCount] = response;
    setMailItem((prevMailItem: any) => ({
      ...prevMailItem,
      [isReadMail ? 'readMail' : 'unReadMail']: updatedMail,
      [isReadMail ? 'readMailCount' : 'unReadMailCount']: updatedMailCount,
      isloading: false,
    }));

    setPageNumber(pagenumber);
  };

  const paginationHandler = async (number: any) => {
    try {
      const searchValues = dashboardStore.dashboard.searchfilterparams;
      const orderData = dashboardStore.dashboard.orderData;
      const orderName = dashboardStore.dashboard.orderName;
      const isReadMail = tableName === 'ReadMail';

      let response: any;
      let sort = false;

      if (!_.isEmpty(searchValues) && Object.values(searchValues).every((o) => o !== '') && orderData === '' && orderName === '') {
        const stringfyValue = JSON.stringify(searchValues)
        response = isReadMail
          ? await EmailMessageStore.handleReadMail(stringfyValue, number)
          : await EmailMessageStore.handleUnreadMail(stringfyValue, number);
      } else if (orderData !== '' && orderName !== '') {
        response = isReadMail
          ? await EmailMessageStore.HandlereadMailSortData(orderName, orderData === 'Ascending', number)
          : await EmailMessageStore.HandleunReadMailSortData(orderName, orderData === 'Ascending', number);
        sort = true;
      } else {
        response = isReadMail
          ? await EmailMessageStore.handleReadMail('', number)
          : await EmailMessageStore.handleUnreadMail('', number);
      }

      if (sort) {
        setMailItem((prevMailItem: any) => ({
          ...prevMailItem,
          [isReadMail ? 'readMail' : 'unReadMail']: response,
          isloading: false,
        }));
      } else {
        const [updatedMail, updatedMailCount] = response;
        setMailItem((prevMailItem: any) => ({
          ...prevMailItem,
          [isReadMail ? 'readMail' : 'unReadMail']: updatedMail,
          [isReadMail ? 'readMailCount' : 'unReadMailCount']: updatedMailCount,
          isloading: false,
        }));
      }

      setPageNumber(number);
    } catch (error) {
      console.error("Pagination error:", error);
    }
  };

  const sortHandler = async (headerData: any, OrderDirection: boolean, page: number, condition: string) => {
    const isReadMail = condition === 'ReadMail';
    const Response: any = isReadMail
      ? await EmailMessageStore.HandlereadMailSortData(headerData, OrderDirection, page)
      : await EmailMessageStore.HandleunReadMailSortData(headerData, OrderDirection, page);

    setMailItem((prevMailItem: any) => ({
      ...prevMailItem,
      [isReadMail ? 'readMail' : 'unReadMail']: Response,
      isloading: false,
    }));
  };

  return (
    <div style={{marginTop:'-13px'}}>
      <DynamicTableComponent
        data={tableDetails}
        name={tableName}
        actiontype={''}
        pageFunc={paginationHandler}
        pageNumData={pageNumber}
        loading={loading}
        pageSize={pageSize}
        ReadMailCheckboxFunc={ReadMailCheckboxFunc}
        EmailsearchHandler={searchHandler}
        searchFuncData={''}
        sortHandler={sortHandler}
      />
    </div>
  );
};

export default observer(EmailTable);
